RivalIQ.apps.SocialPosts.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const OwnedVsCuratedCellView = Marionette.ItemView.extend({
        tagName: 'td',
        className: 'metric-table-cell',

        template: '#ownedVsCuratedCellTooltip',

        serializeData: function () {
            const me = this;

            const metric = me.getOption('model');
            const data = me.getOption('data');

            const value = _.last(data);
            const tooltipTemplate = Marionette.TemplateCache.get('#tableCellTooltip');
            const tipValue = (_.isNumber(value) ? metric.formatExpanded(data) : '--');
            const tooltip = tooltipTemplate({
                name: metric.getName(),
                value: tipValue
            });

            let boldValue = false;
            if (me.compareIndex) {
                const compareValue = _.last(_.get(me.getOption('rows'), [me.getOption('index'), me.compareIndex]));

                if (_.isFinite(compareValue) && _.isFinite(value) && value > compareValue) {
                    boldValue = true;
                }
            }

            return {
                value: metric.format(data),
                tooltip: tooltip,
                boldValue: boldValue
            };
        }
    });

    const LinksPosted = Dashboard.widgets.SummarizedTableWidget.mixin({
        mixins: {
            linksTableWidgetCsv: App.mixins.LinksTableWidgetCsv
        },
        expansionTracking: RivalIQ.tracking.metric.PostedURLsExpandedTableRow,
        view: App.views.BaseSummarizedTableWidget.extend({
            widgetClassName: 'links-posted-owned-vs-curated-table',
            sortAttrPrefix: 'companyIdPrimaryDomain',
            sendMultipleSortCols: true,
            dimensionViewMoreMetricProperty: 'shared_domain_count_distinct',
            dimensionViewMoreLinkName: 'View Domains'
        }),
        title: RivalIQ.strings.social_post_links_posted_owned_vs_curated_title,
        description: RivalIQ.strings.social_post_links_posted_owned_vs_curated_description,
        viewMorePath: function (overrides) {
            const me = this;
            const props = _.defaults(overrides || {}, {
                limit: -1,
                instanceId: 'links-posted-owned-vs-curated'
            }, _.pick(me.getProps(), App.utils.validCurationOptions));
            const route = Dashboard.router.router.resolveCurationRoute(me.curation.id, props);
            return route;
        },
        getBaseMetric: function () {
            return new RivalIQ.models.MetricDefinition({
                concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS_POSTED_URLS.id,
                dimensions: ['companyId']
            });
        },
        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                filter: false,
                showDescriptions: true,
                domainsOnly: true,
                sortable: true,
                sortOrder: 1,
                dimension: 'primaryDomain',
                metrics: [
                    {
                        name: 'Company',
                        property: 'count', // CompanyLinkFilterCell assumes the property is count
                        sortable: false
                    },
                    {
                        property: 'shared_url_pct_curated',
                        dimensionView: {
                            render: _.noop
                        }
                    },
                    {
                        property: 'shared_url_count_distinct_owned'
                    },
                    {
                        property: 'shared_url_count_distinct_curated'
                    },
                    {
                        property: 'avg_engagement_rate_per_post_owned'
                    },
                    {
                        property: 'avg_engagement_rate_per_post_curated'
                    },
                    {
                        property: 'avg_shared_urls'
                    }
                ]
            });

            _.extend(props.metrics[0], {
                cellView: _.constant(RivalIQ.apps.SocialPosts.views.CompanyLinkFilterCell),
                dimensionView: RivalIQ.apps.SocialPosts.widgets.SharedDomainSubordinateCell
            });

            const ownedEngRateIdx = _.findIndex(props.metrics, {
                property: 'avg_engagement_rate_per_post_owned'
            });
            const curatedEngRateIdx = _.findIndex(props.metrics, {
                property: 'avg_engagement_rate_per_post_curated'
            });
            if (ownedEngRateIdx >= 0 && curatedEngRateIdx >= 0) {
                _.extend(props.metrics[ownedEngRateIdx], {
                    cellView: _.constant(OwnedVsCuratedCellView.extend({
                        compareIndex: curatedEngRateIdx
                    })),
                    dimensionView: OwnedVsCuratedCellView
                });
                _.extend(props.metrics[curatedEngRateIdx], {
                    cellView: _.constant(OwnedVsCuratedCellView.extend({
                        compareIndex: ownedEngRateIdx
                    })),
                    dimensionView: OwnedVsCuratedCellView
                });
            }


            if (!me.metric) {
                me.metric = me.getBaseMetric();
            }

            App.utils.updateMetric(me.metric, props);

            me.metricsCollection = props.metrics;
            RivalIQ.models.MetricDefinition.build(me, me.metric, {}, 'metricsCollection');

            me.summaryMetrics = me.getSummaryMetrics(props);

            return props;
        },
        getSummaryMetrics: function (props) {
            const metric = RivalIQ.metric.build(props, {
                // NOTE we don't care about `orderBy` for summary metrics, and
                // to leave it as is can cause server errors on requests
                orderBy: undefined,
                concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS_POSTED_URLS.id,
                dimensions: ['companyId']
            });

            const focusMetric = RivalIQ.metric.build(metric, {
                companyId: props.focusCompanyId
            });

            const landscapeAverageMetric = RivalIQ.metric.build(metric, {
                name: 'Landscape Avg.',
                dimensions: []
            }, {
                clobberDimensions: true
            });

            const audienceName = props.channel === 'facebook' ? 'Page Fan' : 'Follower';

            const metrics = [
                {
                    metrics: [
                        RivalIQ.metric.build(focusMetric, {
                            name: 'Your Owned URLs',
                            description: RivalIQ.strings.your_count_owned_link_description,
                            property: 'shared_url_count_distinct_owned'
                        }),
                        RivalIQ.metric.build(landscapeAverageMetric, {
                            property: 'avg_shared_url_count_distinct_owned'
                        })
                    ]
                },
                {
                    metrics: [
                        RivalIQ.metric.build(focusMetric, {
                            name: 'Your Curated URLs',
                            description: RivalIQ.strings.your_count_curated_link_description,
                            property: 'shared_url_count_distinct_curated'
                        }),
                        RivalIQ.metric.build(landscapeAverageMetric, {
                            property: 'avg_shared_url_count_distinct_curated'
                        })
                    ]
                },
                {
                    metrics: [
                        RivalIQ.metric.build(focusMetric, {
                            name: `Your Owned Eng. Rate by ${audienceName}`,
                            abbreviatedName: 'Your Owned Eng. Rate',
                            description: RivalIQ.str('average_owned_link_engagement_rate_description', audienceName.toLowerCase()),
                            property: 'avg_engagement_rate_per_post_owned'
                        }),
                        RivalIQ.metric.build(landscapeAverageMetric, {
                            property: 'avg_engagement_rate_per_post_owned'
                        })
                    ]
                },
                {
                    metrics: [
                        RivalIQ.metric.build(focusMetric, {
                            name: `Your Curated Eng. Rate by ${audienceName}`,
                            abbreviatedName: 'Your Curated Eng. Rate',
                            description: RivalIQ.str('average_curated_link_engagement_rate_description', audienceName.toLowerCase()),
                            property: 'avg_engagement_rate_per_post_curated'
                        }),
                        RivalIQ.metric.build(landscapeAverageMetric, {
                            property: 'avg_engagement_rate_per_post_curated'
                        })
                    ]
                }
            ];

            return new Backbone.Collection(metrics);
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SOCIAL_POSTS_LINKS_POSTED_OWNED_VS_CURATED_TABLE, LinksPosted);

});
